import React, { useEffect, useRef, useState } from 'react';
import moment from 'moment';
import './product.scss';
import securityService from '../security/security.service';
import productService from './product.service';
import saleInvoiceService from '../sale-invoice/sale-invoice.service';
import hardDeleteService from '../../services/hard-delete.service';
import { DialogComponent } from '@syncfusion/ej2-react-popups';
import {
  GridComponent, ColumnsDirective, ColumnDirective,
  Page, Sort, Resize, Selection, Edit, Toolbar, Inject
} from '@syncfusion/ej2-react-grids';
import dropdownService from '../software-dynamic-version-5/api.service-v-5'; // optional if you want to re-use dropdownApi
import { AutoComplete } from "@syncfusion/ej2-dropdowns";
import AddNewDialog from '../software-dynamic-version-7/addNew-popup-list-v-7';

import {
  StructuredGenerate,
  DynamicDropDownInput,
  DynamicNumericInput,
  DynamicDateInput,
  DynamicTextInput,
  DynamicHiddenInput
} from '../software-dynamic-version-6/mainSection-multiple-inputs-v-6';

const ProductAdd = (props) => {
  let {
    DynamicDropDownInput: DropdownComponent,
    DynamicNumericInput: NumberComponent,
    DynamicDateInput: DateComponent,
    DynamicTextInput: TextComponent,
    DynamicHiddenInput: HiddenComponent
  } = { DynamicDropDownInput, DynamicNumericInput, DynamicDateInput, DynamicTextInput, DynamicHiddenInput };

  const grid = useRef(null);

  const [detailDS, setDetailDS] = useState([]);
  const [deleteTask, setDeleteTask] = useState({ visible: false, row: null, mode: null });

  const [inputProps, setInputProps] = useState({
    ProductID: { name: 'ProductID', value: props.ProductID || undefined },

    ProductDescription1: {
      name: { id: 'ProductDescription1ID', value: 'ProductDescription1' },
      caption: securityService.getCaptionForDescriptionInputs('ProductDescription1') || 'Description 1',
      value: { id: props.ProductDescription1ID || 1, value: props.ProductDescription1 || 'TRADING' },
      dataSource: { type: 'Route', route: 'ProductDescription1' },
      isControlBlur: false,
      addNew: {
        Route: 'ProductDescription1',
        Security: localStorage.getItem('ShowPurchaseChallan') == 'true',
        PopupHeading: `ADD NEW ${securityService.getCaptionForDescriptionInputs('ProductDescription1') || 'Description 1'}`
      }
    },
    ProductDescription1ID: { name: 'ProductDescription1ID', value: props.ProductDescription1ID || 1 },

    OpeningDate: { name: 'OpeningDate', value: props.OpeningDate || 'currentDate' },

    ProductDescription2: {
      name: { id: 'ProductDescription2ID', value: 'ProductDescription2' },
      caption: securityService.getCaptionForDescriptionInputs('ProductDescription2') || 'Description 2',
      value: { id: props.ProductDescription2ID || 0, value: props.ProductDescription2 || '' },
      dataSource: { type: 'Route', route: 'ProductDescription2' },
      isControlBlur: false,
      addNew: { Route: 'ProductDescription2', Security: localStorage.getItem('ShowPurchaseChallan') == 'true', PopupHeading: `ADD NEW Description 2` }
    },
    ProductDescription3: {
      name: { id: 'ProductDescription3ID', value: 'ProductDescription3' },
      caption: securityService.getCaptionForDescriptionInputs('ProductDescription3') || 'Description 3',
      value: { id: props.ProductDescription3ID || 0, value: props.ProductDescription3 || '' },
      dataSource: { type: 'Route', route: 'ProductDescription3' },
      isControlBlur: false,
      addNew: { Route: 'ProductDescription3', Security: localStorage.getItem('ShowPurchaseChallan') == 'true', PopupHeading: `ADD NEW Description 3` }
    },
    ProductDescription4: {
      name: { id: 'ProductDescription4ID', value: 'ProductDescription4' },
      caption: securityService.getCaptionForDescriptionInputs('ProductDescription4') || 'Description 4',
      value: { id: props.ProductDescription4ID || 0, value: props.ProductDescription4 || '' },
      dataSource: { type: 'Route', route: 'ProductDescription4' },
      isControlBlur: false,
      addNew: { Route: 'ProductDescription4', Security: localStorage.getItem('ShowPurchaseChallan') == 'true', PopupHeading: `ADD NEW Description 4` }
    },
    ProductDescription5: {
      name: { id: 'ProductDescription5ID', value: 'ProductDescription5' },
      caption: securityService.getCaptionForDescriptionInputs('ProductDescription5') || 'Description 5',
      value: { id: props.ProductDescription5ID || 0, value: props.ProductDescription5 || '' },
      dataSource: { type: 'Route', route: 'ProductDescription5' },
      isControlBlur: false,
      addNew: { Route: 'ProductDescription5', Security: localStorage.getItem('ShowPurchaseChallan') == 'true', PopupHeading: `ADD NEW Description 5` }
    },
    ProductDescription6: {
      name: { id: 'ProductDescription6ID', value: 'ProductDescription6' },
      caption: securityService.getCaptionForDescriptionInputs('ProductDescription6') || 'Description 6',
      value: { id: props.ProductDescription6ID || 0, value: props.ProductDescription6 || '' },
      dataSource: { type: 'Route', route: 'ProductDescription6' },
      isControlBlur: false,
      addNew: { Route: 'ProductDescription6', Security: localStorage.getItem('ShowPurchaseChallan') == 'true', PopupHeading: `ADD NEW Description 6` }
    },

    ProductName: { name: 'ProductName', value: props.ProductName || '', caption: 'Product Name', enabled: true },

    hsCode: {
      name: { id: 'hsCodeID', value: 'hsCode' },
      caption: 'HS Code',
      value: { id: props.hS_CODE || null, value: '' },
      dataSource: { type: 'Data', data: [] },
      isControlBlur: false
    },

    UnitOfMeasurement: {
      name: { id: 'UnitOfMeasurementID', value: 'UnitOfMeasurement' },
      caption: 'Unit Of Measurement',
      value: { id: props.UnitOfMeasurementID || null, value: props.UnitOfMeasurement || '' },
      dataSource: { type: 'Route', route: 'UnitOfMeasurementDDSource' },
      isControlBlur: false,
      addNew: { Route: 'UnitOfMeasurement', Security: localStorage.getItem('ShowSaleChallan') == 'true' }
    },
    uoM: {
      name: { id: 'uoMID', value: 'uoM' },
      caption: 'Unit of Measurement',
      value: { id: null, value: props.uoM || '' },
      dataSource: { type: 'Data', data: [] },
      isControlBlur: false
    }
  });

  // ─── helpers ────────────────────────────────────────────────────
  const updateMainSecionsValue = (valueObj) => {
    setInputProps((prev) => {
      const next = { ...prev };
      Object.keys(valueObj).forEach((k) => {
        if (next[k]) next[k] = { ...next[k], ...valueObj[k] };
      });
      return next;
    });
  };

  const toNum = (v) => {
    const n = parseFloat((v ?? '0').toString().replace(/,/g, ''));
    return isNaN(n) ? 0 : n;
  };

  // ─── load data ──────────────────────────────────────────────────
  useEffect(() => {
    if (props.getDetails) props.getDetails([])
    if (props.isAdd === false) {
      getUOMDataSource(props.hS_CODE);
      loadOpeningDetail(props.ProductID);
    }
    loadHSCodeSource();
  }, []);

  const loadOpeningDetail = async (ProductID) => {
    try {
      const resp = await productService.getForList();
      const rows = resp?.data?.recordset || [];
      // const resp = await productService.getOpeningDetail();
      // attach calculated columns
      const mapped = rows.filter((v)=>v.ProductID == ProductID).map((r, i) => {
        const qty  = toNum(r.OpeningQuantity);
        const rate = toNum(r.OpeningRate);
        const tax  = toNum(r.TaxPercent);
        const openingAmount = qty * rate;
        const taxAmount     = openingAmount * (tax / 100);
        return { ...r, IndexID: i + 1, OpeningAmount: openingAmount, TaxAmount: taxAmount, TotalAmount: openingAmount + taxAmount };
      });

      console.log(mapped)
      setDetailDS(mapped);
    } catch (err) {
      console.error('loadOpeningDetail error:', err);
    }
  };

  const loadHSCodeSource = async () => {
    try {
      const CompanyID = securityService.getCompanyIDLoggedInUserId();
      const response = await saleInvoiceService.getItemDescCode(CompanyID);
      if (response?.data) {
        const hsCodeData = response.data.map((row) => ({ id: row.hS_CODE, value: `${row.hS_CODE} | ${row.description}` }));
        updateMainSecionsValue({ hsCode: { dataSource: { type: 'Data', data: hsCodeData } } });
        if (props.isAdd === false) {
          setTimeout(() => {
            const match = hsCodeData.find((e) => e.id == props.hS_CODE);
            updateMainSecionsValue({ hsCode: { value: { id: props.hS_CODE, value: match?.value || '' } } });
            const el = document.getElementById('hsCode');
            if (el) el.value = match?.value || '';
          }, 600);
        }
      }
    } catch (err) {
      console.error('loadHSCodeSource error:', err);
    }
  };

  const getUOMDataSource = async (hsCodeValue = inputProps.hsCode.value.id) => {
    try {
      const CompanyID = securityService.getCompanyIDLoggedInUserId();
      const data = { CompanyID, hs_code: hsCodeValue, annexure_id: 3 };
      if (!data.hs_code) return;
      const response = await saleInvoiceService.getUOMDDSource(data);
      if (response?.data) {
        const uoMDataSource = response.data.map((row) => ({ id: row.uoM_ID, value: row.description }));
        updateMainSecionsValue({ uoM: { dataSource: { type: 'Data', data: uoMDataSource } } });
        if (props.isAdd === false) {
          setTimeout(() => {
            updateMainSecionsValue({ uoM: { value: { id: props.uoM, value: props.uoM } } });
          }, 600);
        }
      }
    } catch (err) {
      console.error('getUOMDataSource error:', err);
    }
  };

  // ─── main section handlers ───────────────────────────────────────
  const generateProductName = (updatedInputs) => {
    const parts = [
      updatedInputs.ProductDescription1?.value?.value || 'TRADING',
      updatedInputs.ProductDescription2?.value?.value,
      updatedInputs.ProductDescription3?.value?.value,
      updatedInputs.ProductDescription4?.value?.value,
      updatedInputs.ProductDescription5?.value?.value,
      updatedInputs.ProductDescription6?.value?.value
    ].filter(Boolean);
    return parts.join('-');
  };

  const handleInputCreated = (e, name) => {
    if (name === 'OpeningDate' && document.getElementById('OpeningDate')) {
      document.getElementById('OpeningDate').focus();
      document.getElementById('OpeningDate').select();
    }
  };


  const handleInputBlur = async  (value, name) => {
    // console.log(value);
    // console.log(`Input ${name} focus to ${value}`);
    if(name == 'uoM' && props.isAdd == true){
      setTimeout(() => {
      grid.current.addRecord();
    }, 600);
    }
  };
  const handleInputChange = (value, name) => {
    const updatedInputs = { ...inputProps };
    if (name.includes('ProductDescription') || name === 'ProductName') {
      updatedInputs[name] = { ...inputProps[name], value: name === 'ProductName' ? inputProps[name].value : value };
      updatedInputs.ProductName = { ...inputProps.ProductName, value: generateProductName(updatedInputs) };
    } else if (name === 'hsCode') {
      updatedInputs[name] = { ...inputProps[name], value };
      getUOMDataSource(value.id);
    } else {
      updatedInputs[name] = { ...inputProps[name], value };
    }
    setInputProps(updatedInputs);
  };

  // ─── grid: calculations ──────────────────────────────────────────
  const recalc = (form) => {
    const qty  = toNum(document.getElementById('ProductOpeningDetailOpeningQuantity')?.value);
    const rate = toNum(document.getElementById('ProductOpeningDetailOpeningRate')?.value);
    const tax  = toNum(document.getElementById('ProductOpeningDetailTaxPercent')?.value);
    const openingAmount = qty * rate;
    const taxAmount     = openingAmount * (tax / 100);
    const totalAmount   = openingAmount + taxAmount;
    if (form?.elements['ProductOpeningDetailOpeningAmount'])
      form.elements['ProductOpeningDetailOpeningAmount'].ej2_instances?.[0] && (form.elements['ProductOpeningDetailOpeningAmount'].ej2_instances[0].value = openingAmount);
    if (form?.elements['ProductOpeningDetailTaxAmount'])
      form.elements['ProductOpeningDetailTaxAmount'].ej2_instances?.[0] && (form.elements['ProductOpeningDetailTaxAmount'].ej2_instances[0].value = taxAmount);
    if (form?.elements['ProductOpeningDetailTotalAmount'])
      form.elements['ProductOpeningDetailTotalAmount'].ej2_instances?.[0] && (form.elements['ProductOpeningDetailTotalAmount'].ej2_instances[0].value = totalAmount);
  };
 // ==================== Grid dropdown editor (AutoComplete) ====================
 const handleInputFocused = (inputRef, isGrid) => {
  if (isGrid) {
    if (inputRef) inputRef.showPopup();
  } else {
    if (inputRef) inputRef.current.showPopup();
  }
};

// const getDataSource = async (routeKey, obj) => {
//   // Option 1: use invoice endpoints (uncomment if you prefer)
  
//   // if (routeKey === "HSCodeDDSource") { const r = await invoiceService.getHSCodeDDSource(); obj.dataSource = r.data.recordset; return; }
//   // if (routeKey === "UnitOfMeasurementDDSource") { const r = await invoiceService.getUnitOfMeasurementDDSource(); obj.dataSource = r.data.recordset; return; }
  
//   // Option 2 (default here): use your existing dropdownApi service
//   const response = await dropdownService.getAllForList(routeKey);
//   obj.dataSource = response?.data?.recordset || [];
// };

const getDataSource = async (routeKey, obj) => {
  try {
    switch (routeKey) {
      // case "HSCodeDDSource": {
      //   const companyID = securityService.getCompanyIDLoggedInUserId();
      //   const hsRes = await saleInvoiceService.getItemDescCode(companyID);
      //   obj.dataSource = (hsRes?.data || []).map(r => ({
      //     id: r.hS_CODE,
      //     value: `${r.hS_CODE} | ${r.description}`
      //   }));
      //   break;
      // }
      
      case "ItemDescriptionSource": 
       const response1 = await dropdownService.getAllForList(routeKey);
        obj.dataSource = response1?.data?.recordset || [];
      //{ // Example for future
      //   const companyID = securityService.getCompanyIDLoggedInUserId();
      //   const res = await saleInvoiceService.getItems(companyID);
      //   obj.dataSource = (res?.data || []).map(r => ({
      //     value: r.itemCode,
      //     text: r.itemName
      //   }));
      //   break;
      // }
      
      default:
        // Default dropdown service
        const response = await dropdownService.getAllForList(routeKey);
        obj.dataSource = response?.data?.recordset || [];
    }
  } catch (error) {
    console.error(`Error loading ${routeKey}:`, error);
    obj.dataSource = [];
  }
};

const autoCompleteInstances = {};

const createAutoComplete = (params) => {
  let obj : AutoComplete;
    let elem : HTMLElement;

  const create = () => {
    elem = document.createElement("input");
    return elem;
  };
  const destroy = () => obj?.destroy();
  const read = () => obj?.text;

  const write = async (args) => {
    const dynamicKey = `obj_${params.field.id}`;

    autoCompleteInstances[dynamicKey]  = new AutoComplete({
      value: args.rowData[params.field.value],
      fields: { value: "value"},
      placeholder: `Select ${params.caption}`,
      highlight: true,
      showClearButton: false,

      created: async (arg) => {
        console.log(args)
        console.log(arg)
        if (params?.source?.type === "Route") {
          await getDataSource(params.source.dataSource,  autoCompleteInstances[dynamicKey] );
        } else if (params?.source?.type === "Data") {
          autoCompleteInstances[dynamicKey].dataSource = params?.source?.dataSource || [];
        }
      if(args.requestType == 'beginEdit'){
        autoCompleteInstances[dynamicKey].dropdownValues =  { id:args.rowData[params.field.id],  value: args.rowData[params.field.value],...args.rowData}
      }
        if (params.onCreated) {
          params.onCreated(
            {
              ...args.rowData,
              id: args.rowData[params.field.id],
              value: args.rowData[params.field.value],
            },
            params.field.value,
            args,
            autoCompleteInstances
          );
        }
      },

      focus: () => handleInputFocused( autoCompleteInstances[dynamicKey] , true),

      select: async (e) => {
        // assign id + value fields
        console.log(e)
        // autoCompleteInstances[dynamicKey].itemData =  { ...e.itemData, id: e.itemData?.id, value: e.itemData?.value };
        autoCompleteInstances[dynamicKey].dropdownValues =  { id: e.itemData?.id ,  value: e.itemData?.value,...e.itemData}
        if (params.field.id) args.rowData[params.field.id] = e.itemData.id;
        args.rowData[params.field.value] = e.itemData.value;

        if (params.onSelect) {
          params.onSelect(
            { ...e.itemData, id: e.itemData?.id, value: e.itemData?.value },
            params.field.value,
            args,
            autoCompleteInstances
          );
        }
      },

      change: (e) => {
        console.log(e)
        // autoCompleteInstances[dynamicKey].itemData =  { ...e.itemData, id: e.itemData?.id, value: e.itemData?.value };
        autoCompleteInstances[dynamicKey].dropdownValues =  { id: e?.itemData?.id ,  value: e?.itemData?.value,...e.itemData}
        const ds = Array.isArray( autoCompleteInstances[dynamicKey] .dataSource) ?  autoCompleteInstances[dynamicKey] .dataSource : [];
        const isValid = ds.some((s) => s.value === e.value);
        if (!isValid) {
          if (params.field.id) args.rowData[params.field.id] = undefined;
          args.rowData[params.field.value] = e?.value;
        } else {
          const selectedItem = ds.find((s) => s.value === e.value);
          if (params.field.id) args.rowData[params.field.id] = selectedItem.id;
          args.rowData[params.field.value] = selectedItem.value;
        }
      }
    });

    autoCompleteInstances[dynamicKey] .appendTo(elem);
    // autoCompleteInstances[dynamicKey] = obj;
  };

  return { create, destroy, read, write };
};



  // ─── grid: actionBegin ───────────────────────────────────────────
  const actionBegin = (args) => {
    if (args.requestType === 'add') {
      args.data.GDID            = 0;
      args.data.GDNo            = '';
      args.data.OpeningQuantity = 0;
      args.data.OpeningRate     = 0;
      args.data.TaxPercent      = 0;
      args.data.OpeningAmount   = 0;
      args.data.TaxAmount       = 0;
      args.data.TotalAmount     = 0;
    }
    if (args.requestType === 'delete') {
      args.cancel = true;
      const row = Array.isArray(args.data) ? args.data[0] : args.data;
      setDeleteTask({ visible: true, mode: 'confirm', row });
    }
  };

  // ─── grid: actionComplete ────────────────────────────────────────
  const actionComplete = async (args) => {
    if (args.requestType === 'beginEdit' || args.requestType === 'add') {
      ['OpeningQuantity', 'OpeningRate', 'TaxPercent'].forEach((f) => {
        const el = document.getElementById(`ProductOpeningDetail${f}`);
        if (el) {
          el.addEventListener('input',  () => recalc(args.form));
          el.addEventListener('keyup',  () => recalc(args.form));
          el.addEventListener('keydown',() => recalc(args.form));
        }
      });


      document.getElementById('ProductOpeningDetailTaxPercent')
        ?.addEventListener('keydown', (e) => {
          e.stopPropagation();
          if (e.key === 'Tab') setTimeout(() => grid.current.endEdit(), 200);
        });
    }

    if (args.requestType === 'save') {
      const copyData = [...grid.current.dataSource];
      const targetIndex = args.action === 'add' ? 0 : args.rowIndex;

      const qty  = toNum(args.data.OpeningQuantity);
      const rate = toNum(args.data.OpeningRate);
      const tax  = toNum(args.data.TaxPercent);
      const openingAmount = qty * rate;
      const taxAmount     = openingAmount * (tax / 100);
      const totalAmount   = openingAmount + taxAmount;

      copyData[targetIndex] = {
        ...copyData[targetIndex],
        ...args.data,
        IndexID:       args.action === 'add' ? copyData.length : args.data.IndexID,
        OpeningAmount: openingAmount,
        TaxAmount:     taxAmount,
        TotalAmount:   totalAmount,
        GDID:  autoCompleteInstances['obj_GDID']?.dropdownValues?.id  || 0  ,
        GDNo:  autoCompleteInstances['obj_GDID']?.dropdownValues?.value 

      
      };

      setDetailDS(copyData);
      if (props.getDetails) props.getDetails(copyData.filter((r) => !r.ProductOpeningDetailID));

      // DB update for existing rows
      if (args.action === 'edit' && args.data.ProductOpeningDetailID) {
        await productService.updateDetailData(copyData[targetIndex]);
      }

      // auto-advance
      if (args.action === 'edit') {
        const len = grid.current.currentViewData.length;
        setTimeout(() => {
          const next = args.rowIndex + 1;
          if (next < len) { grid.current.selectRow(next); grid.current.startEdit(); }
        }, 600);
      } else {
        setTimeout(() => grid.current.addRecord(), 600);
      }
    }
  };

  // ─── grid: delete ────────────────────────────────────────────────
  const handleConfirmOk = async () => {
    const row = deleteTask.row;
    if (!row) { setDeleteTask({ visible: false, mode: null, row: null }); return; }
    try {
      if (row.ProductOpeningDetailID) {
        await hardDeleteService.hardDelete({ TableName: 'ProductOpeningDetail', ColumnName: 'ProductOpeningDetailID', RowID: row.ProductOpeningDetailID });
      }
      const newData = row.ProductOpeningDetailID
        ? detailDS.filter((r) => r.ProductOpeningDetailID !== row.ProductOpeningDetailID)
        : detailDS.filter((r) => r.IndexID !== row.IndexID);
      newData.forEach((r, i) => { r.IndexID = i + 1; });
      setDetailDS(newData);
      if (props.getDetails) props.getDetails(newData.filter((r) => !r.ProductOpeningDetailID));
      setDeleteTask({ visible: true, mode: 'success', row: null });
    } catch (err) {
      console.error('Delete failed:', err);
      setDeleteTask({ visible: false, mode: null, row: null });
    }
  };

  const closeDeleteDialog = () => setDeleteTask({ visible: false, mode: null, row: null });

  // ─── grid config ─────────────────────────────────────────────────
  const gridConfig = {
    height: '220',
    width: '100%',
    rowHeight: 25,
    gridLines: 'Horizontal',
    allowPaging: true,
    allowSorting: true,
    allowResizing: true,
    allowSelection: true,
    pageSettings: { pageSize: 10 },
    selectionSettings: { type: 'Single', mode: 'Row' },
    editSettings: { allowAdding: true, allowEditing: true, allowDeleting: true, mode: 'Normal', showDeleteConfirmDialog: false, newRowPosition: 'Top' },
    toolbar: ['Add', 'Edit', 'Delete', 'Update', 'Cancel'],
    aggregates: [{
      columns: [
        { type: 'Sum', field: 'OpeningQuantity', format: 'n2', footerTemplate: (p) => <span style={{ fontWeight: 'bold', color: '#28A745' }}>Sum: {p.Sum}</span> },
        { type: 'Sum', field: 'OpeningAmount',   format: 'n2', footerTemplate: (p) => <span style={{ fontWeight: 'bold', color: '#28A745' }}>Sum: {p.Sum}</span> },
        { type: 'Sum', field: 'TaxAmount',        format: 'n2', footerTemplate: (p) => <span style={{ fontWeight: 'bold', color: '#28A745' }}>Sum: {p.Sum}</span> },
        { type: 'Sum', field: 'TotalAmount',      format: 'n2', footerTemplate: (p) => <span style={{ fontWeight: 'bold', color: '#28A745' }}>Sum: {p.Sum}</span> }
      ]
    }]
  };

  // ─── main section inputs ─────────────────────────────────────────
  const inputsList = [
    { Input: HiddenComponent, Props: { ...inputProps.ProductID,           setInputProps },                                   ColumnSize: 0 },
    { Input: HiddenComponent, Props: { ...inputProps.ProductDescription1ID, setInputProps, onChange: handleInputChange },    ColumnSize: 0 },
    { Input: HiddenComponent, Props: { ...inputProps.ProductDescription1,   setInputProps, onChange: handleInputChange },    ColumnSize: 0 },

    { Input: DateComponent,     Props: { ...inputProps.OpeningDate,          setInputProps, onCreated: handleInputCreated }, ColumnSize: 4 },
    { Input: DropdownComponent, Props: { ...inputProps.ProductDescription2,  setInputProps, onChange: handleInputChange },   ColumnSize: 4 },
    { Input: DropdownComponent, Props: { ...inputProps.ProductDescription3,  setInputProps, onChange: handleInputChange },   ColumnSize: 4 },
    { Input: DropdownComponent, Props: { ...inputProps.ProductDescription4,  setInputProps, onChange: handleInputChange },   ColumnSize: 4 },
    { Input: DropdownComponent, Props: { ...inputProps.ProductDescription5,  setInputProps, onChange: handleInputChange },   ColumnSize: 4 },
    { Input: DropdownComponent, Props: { ...inputProps.ProductDescription6,  setInputProps, onChange: handleInputChange },   ColumnSize: 4 },

    { Input: TextComponent,     Props: { ...inputProps.ProductName,          setInputProps },                                ColumnSize: 12 },
    { Input: DropdownComponent, Props: { ...inputProps.hsCode,               setInputProps, onChange: handleInputChange },   ColumnSize: 12 },
    { Input: DropdownComponent, Props: { ...inputProps.UnitOfMeasurement,    setInputProps },                                ColumnSize: 4 },
    { Input: DropdownComponent, Props: { ...inputProps.uoM,                  setInputProps ,onBlur:handleInputBlur},                                ColumnSize: 4 }
  ];



 

  const onClosing =async (e)=>{
    
    if(e == 'GD'&& document.getElementById('ProductOpeningDetailGDNo')){
  let dynamicKey = `obj_GDID`
  await getDataSource(`GD`, autoCompleteInstances[dynamicKey])
        document.getElementById('ProductOpeningDetailGDNo').focus()
  

}
  }
  return (
    <div>
      <StructuredGenerate
        mainProps={props}
        title={`${props.Title} ${props.isAdd === true ? '- Add' : '- Edit'}`}
        Inputs={inputsList}
      />

     
<br />
      <div>
        
      {/* Confirm dialog */}
      {deleteTask.visible && deleteTask.mode === "confirm" && (
        <DialogComponent visible={true}
        cssClass='product-dialog'
        position={{ X: 'center', Y: 'center' }}   // ✅ THIS LINE
        target={document.body}                // ✅ force full screen context
        

        header="Confirm Delete" content="Are you sure you want to delete this record?" showCloseIcon={false} width="400px" buttons={[ { buttonModel: { content: "OK", isPrimary: true }, click: () => handleConfirmOk()
            },
            {
              buttonModel: { content: "Cancel" },
              click: () => closeDeleteDialog()
            }
          ]}
        />
      )}

      {/* Success dialog */}
      {deleteTask.visible && deleteTask.mode === "success" && (
        <DialogComponent
        cssClass='product-dialog'
        position={{ X: 'center', Y: 'center' }}   // ✅ THIS LINE
        visible={true} header="Success" content="Row deleted successfully." showCloseIcon={false} width="350px" buttons={[ { buttonModel: { content: "OK", isPrimary: true }, click: () => closeDeleteDialog() }
          ]}
        />
      )}
        </div>

      {/* ── Opening Detail Grid ── */}
      <GridComponent
        id="ProductOpeningDetail"
        ref={grid}
        dataSource={detailDS}
        {...gridConfig}
        actionBegin={actionBegin}
        actionComplete={actionComplete}
      >
        <ColumnsDirective>
          <ColumnDirective field="IndexID"                  headerText="ID"         isPrimaryKey width="60"  visible={false} />
          <ColumnDirective field="ProductOpeningDetailID"   headerText="DetailID"   width="80"   visible={false} />
          <ColumnDirective field="GDID"                     headerText="GDID"       width="60"   visible={false} />
       
          <ColumnDirective
              field="GDNo"
              headerText="GD No"
              // visible={localStorage.getItem('ShowPurchaseChallan') == 'true' ? true : false}
              width="120"
              headerTextAlign="center"
              editType="dropdownedit"
              edit={createAutoComplete({
                field: { id: "GDID", value: "GDNo" },
                caption: "GD",
                source: { type: "Route", dataSource: "GD" }
              })}
            />

          <ColumnDirective field="OpeningQuantity" headerText="Qty"       width="110" format="n2" textAlign="right" headerTextAlign="center" editType="numericedit" edit={{ params: { cssClass: 'num-right', format: 'n2' } }} />
          <ColumnDirective field="OpeningRate"     headerText="Rate"      width="110" format="n2" textAlign="right" headerTextAlign="center" editType="numericedit" edit={{ params: { cssClass: 'num-right', format: 'n2' } }} />

          {/* ── Calculated columns ── */}
          <ColumnDirective field="OpeningAmount" headerText="Opening Amt" width="130" format="n2" textAlign="right" headerTextAlign="center" editType="numericedit" edit={{ params: { cssClass: 'num-right', format: 'n2', enabled: false } }} allowEditing={false} />
          <ColumnDirective field="TaxPercent"    headerText="Tax %"       width="90"  format="n2" textAlign="right" headerTextAlign="center" editType="numericedit" edit={{ params: { cssClass: 'num-right', format: 'n2' } }} />
          <ColumnDirective field="TaxAmount"     headerText="Tax Amt"     width="130" format="n2" textAlign="right" headerTextAlign="center" editType="numericedit" edit={{ params: { cssClass: 'num-right', format: 'n2', enabled: false } }} allowEditing={false} />
          <ColumnDirective field="TotalAmount"   headerText="Total"       width="130" format="n2" textAlign="right" headerTextAlign="center" editType="numericedit" edit={{ params: { cssClass: 'num-right', format: 'n2', enabled: false } }} allowEditing={false} />
        </ColumnsDirective>
        <Inject services={[Page, Sort, Resize, Selection, Edit, Toolbar]} />
      </GridComponent>
      <div>

      
      <AddNewDialog 
    Route={'GD'} 
    Security={true} 
    onClosed={onClosing} 
    RefName={'GD'}
    Caption={'ADD NEW GD'}
  />
  </div>
    </div>
  );
};

export default ProductAdd;